import { BROADCAST_SET_ATTENDEE_MUSIC_PROFILE } from 'actions/Types';

export default (attendeeId, contentShareAudioProfile) => {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_ATTENDEE_MUSIC_PROFILE,
      payload: { attendeeId, contentShareAudioProfile }
    };
    dispatch(action);
  };
};
